<div class="clock">
    <span class="clock-time">{{ timeText() }}</span>
    <span class="clock-date">{{ dateText() }}</span>
</div>
